import { ArrowLeft, ArrowRight, Presentation } from "lucide-react";
import { useState } from "react";
import { investorPresentationSlides } from "../../data/investorPresentation";

export default function InvestorPresentation() {
  const [activeIndex, setActiveIndex] = useState(0);
  const activeSlide = investorPresentationSlides[activeIndex];
  const isFirstSlide = activeIndex === 0;
  const isLastSlide = activeIndex === investorPresentationSlides.length - 1;

  const moveSlide = (direction) => {
    setActiveIndex((currentIndex) => {
      return Math.min(
        Math.max(currentIndex + direction, 0),
        investorPresentationSlides.length - 1,
      );
    });
  };

  const slideStyle = activeSlide.image
    ? {
      backgroundImage:
        `linear-gradient(90deg, rgba(0, 0, 0, .9), rgba(0, 0, 0, .48)), `
        + `url(${activeSlide.image})`,
    }
    : undefined;

  return (
    <section className="investor-presentation" data-testid="investor-presentation">
      <div className="investor-presentation-heading">
        <div>
          <span className="eyebrow">Approved investor material</span>
          <h2>GAMEDAY HOLDINGS STRATEGIC OVERVIEW</h2>
        </div>
        <span className="watermark" data-testid="presentation-confidentiality-note">
          Confidential discussion material
        </span>
      </div>
      <article
        className={`investor-presentation-slide ${activeSlide.image ? "has-image" : ""}`}
        data-testid={`investor-presentation-slide-${activeSlide.number}`}
        style={slideStyle}
      >
        <span data-testid="investor-presentation-slide-number">{activeSlide.number} / 10</span>
        <div>
          <Presentation aria-hidden="true" size={25} />
          <p className="eyebrow">{activeSlide.eyebrow}</p>
          <h3>{activeSlide.title}</h3>
          <p>{activeSlide.copy}</p>
          <ul>
            {activeSlide.points.map((point) => (
              <li key={point}>{point}</li>
            ))}
          </ul>
        </div>
      </article>
      <div className="investor-presentation-controls" data-testid="investor-presentation-controls">
        <button
          aria-label="Previous presentation section"
          className="icon-button"
          data-testid="investor-presentation-previous-button"
          disabled={isFirstSlide}
          onClick={() => moveSlide(-1)}
          title="Previous section"
          type="button"
        >
          <ArrowLeft size={18} />
        </button>
        <div
          className="investor-presentation-progress"
          data-testid="investor-presentation-progress"
        >
          {investorPresentationSlides.map((slide, index) => (
            <button
              aria-label={`Open section ${slide.number}`}
              aria-pressed={index === activeIndex}
              className={index === activeIndex ? "active" : ""}
              data-testid={`investor-presentation-step-${slide.number}`}
              key={slide.number}
              onClick={() => setActiveIndex(index)}
              type="button"
            />
          ))}
        </div>
        <button
          aria-label="Next presentation section"
          className="icon-button"
          data-testid="investor-presentation-next-button"
          disabled={isLastSlide}
          onClick={() => moveSlide(1)}
          title="Next section"
          type="button"
        >
          <ArrowRight size={18} />
        </button>
      </div>
    </section>
  );
}